import axios from "axios";
import config from "./config";

export default axios.create({
  baseURL: config.base_url,
  // headers: {
  //   "X-Authorization":
  //     "Bearer ZhceHu2hkYBnkSBinpK2TZE3ByJhbeWqt02zNYG93q2FixCkOd7IJYCnwwj4",
  // },
});
